export const getFileName = (path) => path.split('/').pop();

export const createAndClickLink = (filename, link) => {
    const fileLink = document.createElement('a');
    fileLink.href = link;
    fileLink.setAttribute('download', filename);
    document.body.appendChild(fileLink);
    fileLink.click();
};